import { Navigate } from 'react-router-dom';
import { usePassportCheckinEnabled } from '../hooks/usePassportCheckinEnabled';

/** Blocks Passport desk routes when the franchise uses mobile-only check-in. */
export default function FranchisePassportGate({ children }) {
  const passportCheckin = usePassportCheckinEnabled();
  if (!passportCheckin) {
    return <Navigate to="/nyafaz-ep/partner/check-ins" replace />;
  }
  return children;
}
